var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrayStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5516 1.90849C11.735 1.53687 12.265 1.53687 12.4484 1.90849L15.1165 7.31469C15.1893 7.46226 15.3301 7.56454 15.493 7.58821L21.459 8.45513C21.8691 8.51472 22.0329 9.01871 21.7361 9.30798L17.419 13.5161C17.3012 13.631 17.2474 13.7965 17.2752 13.9587L18.2944 19.9007C18.3644 20.3091 17.9357 20.6206 17.5689 20.4277L12.2327 17.6223C12.087 17.5457 11.913 17.5457 11.7673 17.6223L6.4311 20.4277C6.06428 20.6206 5.63557 20.3091 5.70562 19.9007L6.72475 13.9587C6.75257 13.7965 6.6988 13.631 6.58096 13.5161L2.26385 9.30798C1.9671 9.01871 2.13085 8.51472 2.54096 8.45513L8.50705 7.58821C8.6699 7.56454 8.81069 7.46226 8.88352 7.31469L11.5516 1.90849Z",
    fill: "#E4E4E4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayStar);
export default __webpack_public_path__ + "static/media/grayStar.a837b2b1c141f354a4d5495fca323d99.svg";
export { ForwardRef as ReactComponent };